// extracted by mini-css-extract-plugin
export default {"project_list":"ProjectList_project_list__snyJb","project_list_container":"ProjectList_project_list_container__ujfop"};